export const NAME_PREFIX_DATALIST_ID = 'contact-name-prefix-suggestions';
export const NAME_SUFFIX_DATALIST_ID = 'contact-name-suffix-suggestions';
